import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;
import zoom from 'chartjs-plugin-zoom'

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ['options'],
    mounted () {
          this.addPlugin(zoom);
          this.renderChart(this.chartData, this.options);
      
    } 
  };



//   mounted () {
//     this.renderChart({
//       labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
//       datasets: [
//         {
//           label: 'Data One',
//           backgroundColor: '#f87979',
//           data: [40, 39, 10, 40, 39, 80, 40]
//         }
//       ]
//     }, {responsive: true, maintainAspectRatio: false})
//   }
// }